import { api } from './Api';

export { canViewDirectories as canViewRestaurantDirectory } from './DirectoryAccess';

// Accept decimal numeric API strings, not coercible booleans, blanks or units.
export const normalizePrepTime = (value) => {
  if (typeof value !== 'number' && typeof value !== 'string') return null;
  if (typeof value === 'string' && !/^\d+(?:\.\d+)?$/.test(value.trim())) return null;
  const minutes = Number(value);
  return Number.isFinite(minutes) && minutes >= 0 ? minutes : null;
};

export const parsePrepThreshold = (value) => {
  const input = String(value).trim();
  if (!/^\d+$/.test(input)) return null;
  const minutes = Number(input);
  return Number.isSafeInteger(minutes) && minutes > 0 ? minutes : null;
};

const compareText = (a, b) => {
  const left = String(a ?? '').trim();
  const right = String(b ?? '').trim();
  return left < right ? -1 : left > right ? 1 : 0;
};

export const selectDirectoryRestaurants = (restaurants, { closedOnly, highOnly, threshold, sort }) =>
  restaurants.filter((restaurant) => {
    if (restaurant.isActive !== true) return false;
    const prep = normalizePrepTime(restaurant.prepTime);
    const validThreshold = Number.isSafeInteger(threshold) && threshold > 0;
    return (!closedOnly && !highOnly) ||
      (closedOnly && restaurant.tempClosed === true) ||
      (highOnly && validThreshold && prep != null && prep >= threshold);
  }).slice().sort((a, b) => {
    if (sort === 'highest' || sort === 'lowest') {
      const left = normalizePrepTime(a.prepTime);
      const right = normalizePrepTime(b.prepTime);
      if (left == null && right != null) return 1;
      if (right == null && left != null) return -1;
      if (left != null && right != null && left !== right) {
        return sort === 'highest' ? right - left : left - right;
      }
    }
    return compareText(a.name, b.name) || compareText(a.id, b.id);
  });

// Separate from the map's legacy projection: active is not the same as open.
export const mapRestaurantDirectory = (response) => {
  if (!Array.isArray(response?.results)) {
    throw new Error('Invalid restaurant directory response.');
  }
  return response.results.filter((row) => row?.is_active === true).map((row) => ({
    id: row.id,
    name: row.name,
    isActive: row.is_active,
    prepTime: normalizePrepTime(row.prep_time),
    tempClosed: row.temp_closed,
    tempClosedReason: row.temp_closed_reason,
    phone: row.phone,
    address: row.address,
    city: row.city,
    state: row.state,
    zip: row.zip,
    driverNote: row.driver_note,
  }));
};

// The server enforces the authenticated dispatcher's business scope.
export const getRestaurantDirectory = async () =>
  mapRestaurantDirectory(await api.get('/deliveryops/restaurants', undefined, { cache: 'no-store' }));
